import type { ExchangeRate } from './types';

// Parallel market rates (October 2026) - Lagos/Abuja black market
// Parallel rates are ~2-8% above CBN official rates
const baseParallelRates: Omit<ExchangeRate, 'timestamp' | 'change'>[] = [
  {
    fromCurrency: 'USD',
    toCurrency: 'NGN',
    rate: 1368.00,
    symbol: '$'
  },
  {
    fromCurrency: 'EUR',
    toCurrency: 'NGN',
    rate: 1569.00,
    symbol: '€'
  },
  {
    fromCurrency: 'GBP',
    toCurrency: 'NGN',
    rate: 1900.00,
    symbol: '£'
  },
  {
    fromCurrency: 'CAD',
    toCurrency: 'NGN',
    rate: 1020.00,
    symbol: 'C$'
  },
  {
    fromCurrency: 'AUD',
    toCurrency: 'NGN',
    rate: 970.00,
    symbol: 'A$'
  },
  {
    fromCurrency: 'XOF',
    toCurrency: 'NGN',
    rate: 2.39,
    symbol: 'CFA'
  }
];

// Generate live-like parallel market data with realistic variations
export function generateLiveMockRates(): ExchangeRate[] {
  return baseParallelRates.map(baseRate => {
    const variation = (Math.random() - 0.5) * 0.01;
    const newRate = baseRate.rate * (1 + variation);
    const change = variation * 100;

    return {
      ...baseRate,
      rate: Number(newRate.toFixed(4)),
      change: Number(change.toFixed(3)),
      timestamp: new Date()
    };
  });
}

// Static fallback rates (parallel market rates)
export const mockRates: ExchangeRate[] = baseParallelRates.map(baseRate => ({
  ...baseRate,
  change: (Math.random() - 0.5) * 3,
  timestamp: new Date()
}));
